import { render } from "./Testing.vue?vue&type=template&id=3c1f2ae2&scoped=true"
import script from "./Testing.vue?vue&type=script&lang=js"
export * from "./Testing.vue?vue&type=script&lang=js"

import "./Testing.vue?vue&type=style&index=0&id=3c1f2ae2&scoped=true&lang=css"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1f2ae2"]])

export default __exports__